import { useEffect, useState } from "react";
//--------------------------------------------------------------------------------------------
import { myAxios } from "src/components/common/functions";
import Form from "../form";
export const items = [
    {title: "Rental Start Date", type: "date", required: true},
    {title: "Rental Expire Date", type: "date", required: true},
    {title: "Cost Per Day ($)", type: "number", step: "0.01", required: true},
    {title: "Equipment Name", type: "text", required: true},
    {title: "Equipment ID", type: "text", required: true},
    {title: "Project Name", type:"Select", required: true, options: []},  
    {title: "Vendor Name", type: "text", required: true}, 
    {title: "Vendor Address", type: "text", required: true}, 
    {title: "Condition of equipment at time of rental", example: "New, Fair, Good, Poor", type: "text", required: true},
    {title: "Approver Notes"}
];
//--------------------------------------------------------------------------------------------
export default function RentalForm({
    closeIt, 
    form, 
    picData, setPicData, 
    sketches, setSketches, 
    usersList, setUserList
}){
    const [projects, setProjects] = useState([]);
    items[5].options = projects.map(project => ({
        value: project.projectName, 
        label: project.projectName
    }));
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        let isMounted = true;
        const getData = async () => {
            const resProjectNames = await myAxios("common/readProjectNames.php");
            if(!isMounted) return;
            setProjects(resProjectNames.data);
        }
        getData();
        return () => {isMounted = false;}
    },[]);
    //--------------------------------------------------------------------------------------------
    return(
        <Form
            closeIt = {closeIt}
            form = {form}
            picData = {picData}
            setPicData = {setPicData}
            sketches = {sketches}
            setSketches = {setSketches}
            usersList = {usersList}
            setUserList = {setUserList}

            items = {items}
        />
    )    
}